var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPolyThumbnail = function SvgPolyThumbnail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "#E0BFB8",
    stroke: "#C2604C"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.6,
    d: "M9.979 8.166 8.79 5.17A.5.5 0 0 0 7.974 5L4.3 8.642a.5.5 0 0 0-.141.438l.365 2.18a.5.5 0 0 0 .447.416l4.912.454a.5.5 0 0 0 .309-.072l1.179-.726a.5.5 0 0 0 .216-.278l.402-1.302a.5.5 0 0 0-.261-.598l-1.502-.723a.5.5 0 0 1-.248-.266Z"
  })));
};
export default SvgPolyThumbnail;